import type { Signal, TimeGroup } from "./notifications.types";

// ── Time grouping ─────────────────────────────────────────────────────────────

const GROUP_ORDER = ["This watch", "Previous watch", "Earlier today", "Yesterday", "Older"] as const;

export function getTimeGroup(createdAt: string, now: Date): string {
  const created = new Date(createdAt);
  const diffMs = now.getTime() - created.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffHours < 4) return "This watch";
  if (diffHours < 8) return "Previous watch";

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today.getTime() - 86400000);
  const createdDay = new Date(created.getFullYear(), created.getMonth(), created.getDate());

  if (createdDay.getTime() === today.getTime()) return "Earlier today";
  if (createdDay.getTime() === yesterday.getTime()) return "Yesterday";
  return "Older";
}

export function formatTime(createdAt: string, now: Date): string {
  const created = new Date(createdAt);
  const diffMs = now.getTime() - created.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays}d ago`;
  return created.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export function groupSignals(signals: Signal[], now: Date): TimeGroup[] {
  const grouped = new Map<string, Signal[]>();
  for (const s of signals) {
    const label = getTimeGroup(s.createdAt, now);
    const list = grouped.get(label) ?? [];
    list.push(s);
    grouped.set(label, list);
  }
  return GROUP_ORDER.filter((l) => grouped.has(l)).map((label) => ({
    label,
    signals: grouped.get(label) ?? [],
  }));
}
